





























































































import ALPage from '@/components/core/Page/ALPage.vue';
import moment from 'moment';
import Vue from 'vue';

export default Vue.extend({
  name: 'PriceDistrubutionListPage',

  components: { ALPage },

  data: () => ({
    loading: true,
    distributions: [],
    error: null,
    search: '',

    headers: [
      {
        text: 'Order',
        align: 'start',
        value: 'order',
        sortable: false,
        width: 120
      },
      {
        text: 'Main Item',
        align: 'start',
        value: 'main_item',
        sortable: false,
        width: 90
      },
      {
        text: 'Item Quantity',
        value: 'main_item_quantity',
        sortable: false,
        align: 'end',
        width: 120
      },
      {
        text: 'Item Unit Price',
        value: 'main_item_unit_price',
        sortable: false,
        align: 'end',
        width: 120
      },
      {
        text: 'Item Amount',
        value: 'main_item_amount',
        sortable: false,
        align: 'end',
        width: 120
      },
      {
        text: 'Line',
        align: 'end',
        value: 'line',
        sortable: false,
        width: 70
      },
      {
        text: 'Part Number',
        align: 'start',
        value: 'component_item',
        sortable: false,
        width: 110
      },
      {
        text: 'Description',
        align: 'start',
        value: 'component_description',
        sortable: false,
        width: 250
      },
      {
        text: 'BOM Quantity',
        value: 'component_quantity',
        sortable: false,
        align: 'end',
        width: 110
      },
      {
        text: 'Std. Component Cost',
        value: 'component_unit_cost',
        sortable: false,
        align: 'end',
        width: 150
      },
      {
        text: 'Ext. Component Cost',
        value: 'extended_cost',
        sortable: false,
        align: 'end',
        width: 150
      },
      {
        text: 'Bom cost %',
        value: 'cost_ratio',
        sortable: false,
        align: 'end',
        width: 120
      },
      {
        text: 'Order Quantity',
        align: 'start',
        value: 'order_quantity',
        sortable: false,
        width: 120
      },
      {
        text: 'Proposed Unit Price',
        value: 'prorated_unit_price',
        sortable: false,
        align: 'end',
        width: 150
      },
      {
        text: 'Manufacturer',
        value: 'manufacturer',
        sortable: false,
        width: 120
      },
      {
        text: 'Manufacturer Item',
        value: 'manufacturer_item',
        sortable: false,
        width: 140
      }
    ],

    options: {} as any
  }),

  computed: {
    seriesId(): number | string {
      return this.$route.params.series;
    },

    hasError: {
      get() {
        return !!this.error;
      },
      set() {
        this.error = null;
      }
    }
  },

  methods: {
    getPriceDistribution() {
      this.error = null;
      return this.$axios({
        method: 'get',
        url: `/v1/orders/${this.seriesId}/distribute_price/`,
        timeout: 60 * 1000
      })
        .then(({ data }) => data)
        .catch(err => {
          //TODO: LF-2021-04-07 - I do not think we need the else statement
          if (err.response) {
            this.error = err.response.data.detail;
          } else {
            this.error = err.message;
          }
        });
    },

    exportPriceDistribution() {
      this.error = null;
      return this.$axios({
        method: 'get',
        url: `/v1/orders/export/`,
        responseType: 'blob',
        params: {
          order: this.seriesId
        },
        timeout: 60 * 1000
      })
        .then(async (response: any) => {
          // look into a better way to maintain secuirty
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          const linkName = `${this.seriesId}-price-proposal-${moment(
            new Date()
          ).format('YYYY-MM-DD-HH-mm-ss')}.xlsx`;
          link.href = url;

          link.setAttribute('download', linkName); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(response => {
          console.error(
            'Could not Download the Excel report from the backend.',
            response
          );
        });
    }
  },

  async mounted() {
    this.loading = true;
    this.distributions = await this.getPriceDistribution()
      .catch(err => (this.error = err))
      .finally(() => {
        this.loading = false;
      });
  }
});
